<template>     
  <div id="div-container"></div>
</template>

<script>
import { OpenSheetMusicDisplay } from 'opensheetmusicdisplay'

export default {
  data () {
    return {}
  },
  mounted: function () {
    const container = document.getElementById('div-container')
    const osmd = new OpenSheetMusicDisplay(container)
    osmd.load('/static/music-xml/Sonate_No._14_Moonlight_1st_Movement.mxl').then(function () {
      osmd.render()
    })
  }
}
</script>
<style scoped>
#div-container{
  background-color: white;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/NotationView.vue